export default function() {
    $('body').on('click', '.herald-site-header .herald-menu-popup-search span, .herald-header-sticky .herald-menu-popup-search span', function (e) {
        e.preventDefault();
        $(this).toggleClass('fa-times', 'fa-search');
        $(this).parent().toggleClass('herald-search-active');
        $('.herald-search-active input[type="text"]').focus();

        /* Reverse login form if is out of the screen */
        if ($(this).closest('body').width() < $(document).width()) {
            $(this).siblings('.herald-in-popup').addClass('herald-reverse-form');
        } else {
            $(this).siblings('.herald-in-popup').removeClass('herald-reverse-form');
        }
    }).on('click', '.herald-responsive-header .herald-menu-popup-search span', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(window).width() < 1250) {
            $('.herald-responsive-header .herald-in-popup').css('width', $(window).width());
        }
    });

    $('.herald-responsive-header').on('click', '.herald-menu-popup-search span', function (e) {
        e.preventDefault();
        $(this).next().toggle();
        $(this).toggleClass('fa-times', 'fa-search');
        if ($(window).width() < 1250) {
            $('.herald-responsive-header .herald-in-popup .herald-search-input').focus();
            $('.herald-responsive-header .herald-in-popup').css('width', $(window).width());
        }
    });
}
